export default __webpack_public_path__ + "static/accents-text-accent-tokens-light-30eb503f914fdfb46f969c3e2aedaac8.png";